<template>
    <div v-show="logueado" id="historial" class="container">    
        <div id="filtros" class="separador contenido bg-white br-2-blue mt-4">
            <h2 class="text-center">Historial</h2>
            <div class="container-flex">
                <div class="column">
                    <div class="form-group col-md-12">
                        <label>Fecha Inicio</label>
                        <div>
                            <input class="form-control col-lg-12" type="date" v-model="buscar.fecha_inicial" name="fecha_inicial" />
                        </div>
                    </div>
                    <div class="form-group col-md-12">
                        <label>Fecha Fin</label>
                        <div>
                            <input class="form-control col-lg-12" type="date" v-model="buscar.fecha_final" name="fechafinal" />
                        </div>
                    </div>
                    <div class="form-group col-md-12">
                        <label>Filtro por orden de compra</label>
                        <div>
                            <input class="form-control col-lg-12" type="text" v-model="buscar.orden_de_compra" name="orden_de_compra" />
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="form-group col-md-12">
                        <label>Proceso</label>
                        <select class="form-control" name="estado" v-model="buscar.tipo_proceso">
                            <option selected="selected" value="TODOS">TODOS LOS ESTADOS</option>
                            <option value="TRANSITO">TRANSITO</option>
                            <option value="ENTREGADA">ENTREGADA</option>
                            <option value="SIN SOLICITUD">SIN SOLICITUD</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <label>Contenido / Hawb / Tracking</label>
                        <div>
                            <input class="form-control" type="text" v-model="buscar.str_busqueda" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div>
                    <b-modal title="Rastrear" size="lg" ok-only ok-variant="dark" v-model="modalShow">
                        <div class="panel panel-default ng-scope">
                            <div class="panel-heading font-bold ng-binding">
                                <span>Trackings : {{track}}</span>
                                <br /> Hawb : {{hawb}}
                                <br />
                            </div>
                            <table class="table table-striped b-t ng-hide" v-if="guias_agrupadas.length > 0">
                                <thead>
                                    <tr>
                                        <th colspan="3">Guías agrupadas</th>
                                    </tr>
                                    <tr>
                                        <th>Fecha de creación</th>
                                        <th>HAWB</th>
                                        <th>Tracking</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="guia in guias_agrupadas" v-bind:key="guia.id">
                                        <td>{{guia.created_at}}</td>
                                        <td>{{guia.hawb}}</td>
                                        <td>{{guia.tracking_tienda_casillero}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <!-- ngIf: vm.trackings.length == 0 -->
                            <div class="table-responsive app-table">
                                <table class="table table-striped b-t">
                                    <thead>
                                        <tr>
                                            <th class="text-center" colspan="3">Trackings</th>
                                        </tr>
                                        <tr>
                                            <th>Fecha de creación</th>
                                            <th>Estado</th>
                                            <th>Observación</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="tracking in trackings" v-bind:key="tracking.id">
                                            <td>{{tracking.created_at}}</td>
                                            <td>{{tracking.estado_de_guia.descripcion_alterna}}</td>
                                            <td>{{tracking.observacion}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- ngIf: vm.trackings.length == 0 -->
                            </div>
                        </div>
                    </b-modal>
                </div>
            </div>
            <div class="form-group col-md-12 text-right pr-38">
                <button class="btn btn-blue" @click="changePage()"><b-icon icon="search" aria-hidden="true"></b-icon> Buscar</button>
            </div>
        </div><br/>
        <div id="listar" class="separador contenido bg-white br-2-blue mt-2 mb-4">
            <div class="panel panel-default">
                <div class="wrapper mt-2">
                    <form class="form ng-pristine ng-valid">
                        <div class="row mb-3" v-show="paquetes.length > 0">
                            <div class="col-md-4 col-sm-12 col-xs-4 col-lg-3 ml-1">
                                <button @click="exportExcel()" class="btn-outline-dark btn" type="button"><b-icon icon="cloud-arrow-down" aria-hidden="true" class="text-red"></b-icon>&nbsp;Exportar Excel</button>
                            </div>
                            <div class="form-row justify-content-center col-sm-12 col-md-8 col-lg-8 text-center">
                                <label class="col-md-5 col-lg-2">Registro</label>
                                <div>
                                    <select class="form-control" name="pageSize" v-validate="'required'" @change="changePage()" :class="{ 'is-invalid': submitted && errors.has('pageSize') }" v-model="buscar.pageSize">
                                        <option selected="selected" value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="table-responsive app-table p-1">
                    <table class="table table-striped b-t table-color" id="my-table">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Fecha de creación</th>
                                <th>Tracking</th>
                                <th>HAWB</th>
                                <th>Contenido</th>
                                <th>Estado</th>
                                <th>Peso lbs</th>
                                <th>Observación</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="paquete in paquetes" v-bind:key="paquete.id">
                                <td>
                                    <b-button variant="outline-dark" @click="modalShow = !modalShow ; rastrear(paquete)">
                                        <b-icon icon="truck" aria-hidden="true"></b-icon> Rastrear
                                    </b-button>
                                </td>
                                <td class="ng-binding">{{paquete.created_at}}</td>
                                <td class="ng-binding">{{paquete.tracking_tienda_casillero}}</td>
                                <td class="ng-binding">{{paquete.hawb}}</td>
                                <td class="ng-binding">{{paquete.contenido}}</td>
                                <td class="ng-binding">{{paquete.estados_de_guia_descripcion}}</td>
                                <td class="ng-binding">{{paquete.peso}}</td>
                                <td class="ng-binding">{{paquete.observacion_tracking}}</td>
                            </tr>
                            <tr v-show="paquetes.length == 0 && !cargando">
                                <td colspan="8" class="ng-binding text-center">No hay registros</td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-show="cargando" class="text-center app-bkg-color-f5 app-no-data-table b-t">
                        <Cargando/>
                    </div>
                </div>
                <div class="panel-footer">
                    <b-pagination v-model="buscar.pageNumber" :total-rows="totalRegistros" :per-page="buscar.pageSize" aria-controls="my-table" align="right" v-on:input="changePage"></b-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { api } from "@/plugins/api_conect";
import Cargando from '../layouts/Cargando.vue';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default {
    computed: {
        logueado() {
            return this.$store.getters.loggedIn;
        }
    },
    components: {
      Cargando
    },
    methods: {
        rastrear(paquete) {
            api().get(`/api/casillero/historial/rastrear/${paquete.id}`, {
                    method: "get",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
                    }
                })
                .then((response) => {
                    const { data } = response
                    this.guias_agrupadas = data["datos"]["guias_agrupadas"];
                    this.trackings = data["datos"]["trackings"];
                    this.track = paquete.tracking_tienda_casillero;
                    this.hawb = paquete.hawb;
                    this.rastrearModal = true;
                    this.checked = true;

                }).catch(async (error) => {
                    if (error.response && error.response.status === 401) {
                        await this.$auth.refreshToken();
                        this.rastrear(paquete);
                    }
                    this.checked = true;
                });
        },
        changePage() {
            this.paquetes = [];
            this.cargando = true;
            this.showModal = true;
            this.buscar.pageNumber = parseInt(this.buscar.pageNumber);
            this.buscar.pageSize = parseInt(this.buscar.pageSize);
            api().post(`/api/casillero/clientes/historial/busqueda?page=${this.buscar.pageNumber}`, this.buscar, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
                    },
                })
                .then((response) => {
                    const { data } = response;
                    this.cargando = false;
                    this.paquetes = data["datos"]["data"];
                    this.totalRegistros = data["datos"]["total"];
                    this.showModal = false;
                },async err => {
                  if (err.response && err.response.status === 401){
                    await this.$auth.refreshToken();
                    this.changePage();
                  }
                }).catch( () => {
                    this.$swal('¡ERROR!','Ha ocurrido un error al obtener el historial', 'error')
                });
        },

        toogle() {
            this.crear = true;
        },
        closeCrear() {
            this.crear = false;
            this.clean();
            this.changePage();
        },
        clean() {
            this.preAlerta = {
                tracking: "",
                cliente_id: "",
                tienda_id: "",
                contenido: "",
                destinatario_id: "",
                valor_comercial: "",
                valor_asegurado: "",
                posicion_arancelaria_id: "",
                orden_de_compra: "",
                factura: "",
                notas: "",
                estado: true
            };
        },
        closeModal() {
            this.rastrearModal = false;
        },
        exportExcel(){
          const data = this.paquetes.map(paquete => [
            paquete.created_at,
            paquete.tracking_tienda_casillero,
            paquete.hawb,
            paquete.contenido,
            paquete.estados_de_guia_descripcion,
            paquete.peso,
            paquete.observacion_tracking
          ])
          const headers = ['Fecha creacion', 'Tracking', 'HAWB', 'Contenido', 'Estado de guia', 'Peso', 'Observaciones'];
          const worksheetData = [headers, ...data]
          const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)
          const workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Historial')
          const wbout = XLSX.write(workbook, {bookType: 'xlsx', type: "array"})
          const blob = new Blob([wbout], { type: 'application/vdn.openxmlformats-officedocument.spreadsheetml.sheet' })
          saveAs(blob, 'Historial.xlsx')
        }
    },
    data() {
        return {
            modalShow: false,
            cargando: false,
            track: "",
            hawb: "",
            trackings: "",
            guias_agrupadas: "",
            checked: false,
            rastrearModal: false,
            paquetes: "",
            crear: false,
            submitted: false,
            showModal: false,
            responseMessage: "",
            totalPaginas: 0,
            totalRegistros: 0,

            buscar: {
                fecha_inicial: (new Date()).toISOString().substr(0,10),
                fecha_final: (new Date()).toISOString().substr(0,10),
                str_busqueda: "",
                orden_de_compra: "",
                cliente_id: localStorage.cliente_id,
                tipo_proceso: "TODOS",
                pageNumber: 1,
                pageSize: 10
            }
        };
    },
    mounted: function() {
        this.changePage();
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.contenido {
    padding: 10px;
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.table-color {
    color: black !important;
    background: aliceblue !important;
}
.pr-38 {
    padding-right: 38px;
}
.btn-outline-dark:hover{
    background: var(--primary-color) !important;
    border-color: #343a40 !important;
    color: #fff !important;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
    box-shadow: none !important;
}
</style>